module.exports = {
  /**
   * @type {String} ch en
   * @description 系统语言
   */
  language: 'ch',

  /**
   * @type {String}
   * @description 系统名称
   */
  title: "得乐后台管理系统",

  /**
   * @type {String}
   * @description 系统变量名称
   */
  systemTitle: "dele_admin_vue",

  /**
   * @type {String}
   * @description 系统变量名称
   */
  systemHeaderTop: 85,

  /**
   * @type {String}
   * @description 系统logo
   */
  logo: "https://dele.htennis.net/proApi/little-moth-server/moth/file/common/dele_logo.png",

  /**
   * @type {String}
   * @description 用户logo
   */
  avatar: "https://avatars.githubusercontent.com/u/83387408?s=48&v=4",

  /**
   * @type {String}
   * @description 用户名称
   */
  userName: "webdyc",

  /**
   * @type {String} large| mini | small
   * @description 菜单栏Logo显示
   */
  styleSize: "mini",

  /**
   * @type {boolean} true | false
   * @description 是否显示设置
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description 是否显示面包屑
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description 头部是否吸顶
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description 菜单栏Logo显示
   */
  sidebarLogo: true,
}